(function() {
    'use strict';
    var controllerId = 'BillOfLadingController';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', BillOfLadingController]);

    function BillOfLadingController(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        activate();

        function activate() {
            var promises = [getBol()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated PO List View');
                });
        }

        $scope.reset_order_package = function () {

        };

        function getBol() {

           return datacontext.getBillOfLading({courier_id:1}).then(function(httpResult) {
                vm.bol_array = httpResult.data.data.bolArray;
                vm.pendingcount = httpResult.data.data.pendingCount;

               console.log(httpResult.data.data.pendingCount);
            });

        }

        $scope.createBol = function () {
            return datacontext.createBillOfLading({courier_id:1}).then(function() {
                // refresh page
                getBol();
            });
        };
    }
})();
